<template>
  <router-view>
  </router-view>
</template>

<script>
import './assets/vendor/jquery/jquery.min.js'
import i18n from './lang/i18n.js'
import axios from 'axios'
import moment from 'moment'
import 'moment-timezone'
window.moment = moment

import './assets/vendor/bootstrap/js/bootstrap.bundle.min.js'
import './assets/vendor/jquery-easing/jquery.easing.min.js'
import './assets/js/sb-admin-2.min.js'
import './assets/vendor/highcharts/js/highcharts.js'
import './assets/vendor/highcharts/js/highcharts-more.js' 
import './assets/vendor/highcharts/js/variable-pie.js'
import './assets/vendor/highcharts/js/no-data-to-display.js'
Highcharts.setOptions({
  time: {
    timezone: 'Atlantic/Madeira'
  },
  lang: {
    weekdays: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
    shortMonths:['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    noData: "Sem dados para mostrar", 
    loading: "Carregando"
  }
})

window.moment.locale('pt')

export default {
  name: 'app',
  created: function () {
    /* Axios */
    const self = this
    axios.interceptors.response.use(function (response) {
        return response 
      }, function(err){
        if (err.message == "Request failed with status code 401") {
          self.$store.dispatch('logout').then(() => { 
            self.$router.push({ name: "Login", params:{ message: self.$i18n.t("Session_expired") } }) 
          })
        }
        else return Promise.reject(err)
    });

    /* Matomo */
    window._paq = window._paq || [];
    _paq.push(['requireConsent']);
    _paq.push(['rememberConsentGiven']);
    if (this.$store.getters.isLoggedIn) {
      _paq.push(['setUserId', this.$store.getters.username])
    } 
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
      var u="//ems.prsma.com/matomo/";
      _paq.push(['setTrackerUrl', u+'piwik.php']);
      _paq.push(['setSiteId', '1']);
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'piwik.js'; s.parentNode.insertBefore(g,s);
    })();

  },
}
</script>

<style>
@import './assets/vendor/fontawesome-free/css/all.min.css';
@import './assets/styles/sb-admin-2.min.css';

body {
  background-color: #111827;
}
</style>